import { ForwardedRef, forwardRef, useState } from 'react';

import { Modal } from 'src/common/components';
import { ModalRefProps } from 'src/common/components/Modal';

import { usePhoneListContext } from '../context';

import { AccountsList } from './AccountsList';

export const PhoneAccountModal = forwardRef(
  (props, ref: ForwardedRef<ModalRefProps>): JSX.Element => {
    const { state, actions } = usePhoneListContext();
    const { selectedPhones } = state;
    const { assignToAccount } = actions;
    const [selectedAccount, setSelectedAccount] = useState<string | null>(null);

    const handleAssignAccount = async (): Promise<void> => {
      await assignToAccount(selectedPhones, selectedAccount as string);
    };

    return (
      <Modal
        cancelText="Cancel"
        actionText="Accept"
        actionFunc={handleAssignAccount}
        disabled={!selectedAccount}
        ref={ref}
      >
        <div>
          <h3>Select an account</h3>
          <div className="text-xs text-gray-2.0 mt-2">
            {`Selected phones: ${selectedPhones.length}`}
          </div>
          <div className="px-2 mt-4">
            <AccountsList onChange={setSelectedAccount} defaultValue={selectedAccount} />
          </div>
        </div>
      </Modal>
    );
  }
);
